import request from '@/src/utils/request'

//取得訂單容器付款資訊
export const getMerchantOrderPaymentInfo = async (containerId) => {
  const response = await request.get(`admin/merchant/order/${containerId}/payment-info`)
  return response
}

// 更新訂單容器付款方式與發票資訊
export const updateMerchantOrderPaymentMethod = async (containerId, payload) => {
  const response = await request.patch(`admin/merchant/order/${containerId}/payment-method`, payload)
  return response
}
